<div class="cookie-notice">
  <div [innerHtml]="template"></div>
</div>